import { render, staticRenderFns } from "./role_preview.vue?vue&type=template&id=691d72cf&"
import script from "./role_preview.vue?vue&type=script&lang=js&"
export * from "./role_preview.vue?vue&type=script&lang=js&"
import style0 from "./role_preview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports